import { FilterBarOpenButton } from "./FilterBarOpenButton";
import FilterBar from "./FilterBar";
import { VerticalFilterBarProps } from "../vertical-filter-bar/VerticalFilterBar";
import { useRef, useState } from "react";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

/**
 * A button that opens modal window with the filters (including the modal itself)
 */
export const FilterBarButtonWithModal = (props: VerticalFilterBarProps) => {
    const buttonRef = useRef<HTMLButtonElement | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const sendButtonAnalytics = useButtonAnalytics();

    const handleButtonClick = () => {
        setIsModalOpen(true);
        sendButtonAnalytics("Filters Button", ButtonClickAnalyticsType.FILTER);
    };

    return (
        <>
            <FilterBarOpenButton ref={buttonRef} onClick={handleButtonClick} />

            <FilterBar
                {...props}
                isModalOpen={isModalOpen}
                inModal={true}
                onModalClose={() => {
                    setIsModalOpen(false);
                    // when closing filters modal, focus the button that opened it:
                    buttonRef.current?.focus();
                }}
            />
        </>
    );
};
